
import styled from "styled-components"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({ theme }) => theme.mainTextColor};
    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border-style: solid;
        border-width: ${({ isBold }) => isBold ? "2px" : "1px"};
        border-color: ${({theme, borderColor, isBold}) => !borderColor ? "transparent" : isBold ? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &::placeholder{
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
        }      

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);


    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const InputText = ({data, setData, name, isRequired, labelText="Yükün Türü", inputWidth, borderColor=true, disabled, max, auto, isBold}) => {
  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth} borderColor={borderColor} isBold={isBold}>
        <input autoComplete={auto} maxLength={max} disabled={disabled} type="text" id={"text"} onChange={setData} value={data} name={name}/>
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
    </Container>
  )
}

export default InputText